import React from "react";

function Icon({ fillHover }) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='128'
			height='128'
			fill='none'
			viewBox='0 0 128 128'>
			<path
				className={fillHover}
				d='M35.257 64.59c.107-5.36 4.503-9.755 9.862-9.755 1.93 0 3.752.536 5.253 1.5.643-2.358 2.144-4.395 4.073-5.788-.857-.966-1.93-1.716-3.108-2.144-1.716 1.393-3.86 2.25-6.218 2.25s-4.502-.857-6.218-2.25c-2.144.857-3.858 2.572-4.716 4.824.75 1.393 1.072 2.893 1.072 4.609 0 2.144-.644 4.073-1.822 5.788.642.215 1.178.536 1.822.965z'></path>
			<mask
				id='mask0_413_1653'
				style={{ maskType: "luminance" }}
				width='16'
				height='16'
				x='37'
				y='33'
				maskUnits='userSpaceOnUse'>
				<path fill='#fff' d='M37.547 33.288h15.019v14.84h-15.02v-14.84z'></path>
			</mask>
			<g mask='url(#mask0_413_1653)'>
				<path
					className={fillHover}
					d='M45.119 48.081c4.074 0 7.397-3.324 7.397-7.397s-3.323-7.396-7.397-7.396-7.396 3.323-7.396 7.396 3.322 7.397 7.396 7.397z'></path>
			</g>
			<path
				className={fillHover}
				d='M77.6 56.443c1.501-.966 3.322-1.502 5.253-1.502 5.359 0 9.861 4.395 9.861 9.755a10.68 10.68 0 011.823-1.179c-1.179-1.608-1.823-3.645-1.823-5.789 0-1.608.43-3.216 1.072-4.61-.857-2.143-2.572-3.965-4.716-4.823-1.716 1.394-3.86 2.252-6.217 2.252-2.359 0-4.503-.858-6.219-2.252a10.71 10.71 0 00-3.108 2.144c1.93 1.608 3.431 3.645 4.074 6.004z'></path>
			<mask
				id='mask1_413_1653'
				style={{ maskType: "luminance" }}
				width='16'
				height='16'
				x='75'
				y='33'
				maskUnits='userSpaceOnUse'>
				<path fill='#fff' d='M75.435 33.288h15.018v14.84H75.435v-14.84z'></path>
			</mask>
			<g mask='url(#mask1_413_1653)'>
				<path
					className={fillHover}
					d='M82.853 48.081c4.074 0 7.396-3.324 7.396-7.397s-3.322-7.396-7.396-7.396-7.397 3.323-7.397 7.396c.107 4.073 3.43 7.397 7.397 7.397z'></path>
			</g>
			<path
				className={fillHover}
				d='M54.981 64.696c0 .644-.107 1.287-.215 1.93 1.394-3.751 5.04-6.431 9.22-6.431 4.18 0 7.826 2.68 9.22 6.43-.109-.642-.216-1.285-.216-1.929 0-2.465.966-4.716 2.36-6.432-.43-3.108-2.466-5.681-5.254-6.753-1.715 1.394-3.859 2.252-6.218 2.252-2.358 0-4.502-.858-6.217-2.144-2.787 1.072-4.824 3.644-5.252 6.753 1.607 1.608 2.572 3.859 2.572 6.324zM63.985 51.19c4.075 0 7.397-3.323 7.397-7.397 0-4.073-3.323-7.397-7.397-7.397s-7.396 3.324-7.396 7.397c0 4.18 3.322 7.396 7.396 7.396zM36.544 70.807c-.751-2.466-2.574-4.395-4.932-5.36-1.715 1.393-3.86 2.25-6.218 2.25s-4.501-.857-6.217-2.25c-2.787 1.178-4.93 3.752-5.252 6.861l-.859 6.967c-.106.965.536 1.822 1.395 1.93 3.43.75 7.075 1.18 10.933 1.18 1.823 0 3.646-.108 5.36-.216l.322-3.108c.429-3.645 2.573-6.646 5.468-8.254zM25.395 65.125c4.073 0 7.397-3.322 7.397-7.397 0-4.073-3.324-7.396-7.397-7.396s-7.396 3.323-7.396 7.396c0 4.075 3.323 7.397 7.396 7.397zM114.904 79.275l-.858-6.967c-.321-3.216-2.465-5.79-5.252-6.861-1.716 1.393-3.86 2.25-6.217 2.25-2.359 0-4.503-.857-6.217-2.25-2.359.965-4.182 2.894-4.932 5.36 2.894 1.714 5.038 4.716 5.468 8.254l.321 3.108c1.715.215 3.537.215 5.36.215 3.859 0 7.504-.43 10.933-1.179.859-.108 1.502-.965 1.394-1.93zM102.577 65.125c4.073 0 7.396-3.322 7.396-7.397 0-4.073-3.323-7.396-7.396-7.396s-7.397 3.323-7.397 7.396c0 4.075 3.324 7.397 7.397 7.397zM55.517 76.059c-.965-1.715-2.465-3.002-4.18-3.644-1.716 1.393-3.86 2.25-6.218 2.25s-4.502-.857-6.218-2.25c-2.786 1.178-4.93 3.752-5.252 6.86l-.857 6.968c-.108.857.428 1.716 1.393 1.929 3.431.75 7.183 1.18 10.934 1.18 1.501 0 2.894-.108 4.396-.215l.536-4.716c.428-3.645 2.465-6.646 5.466-8.362zM45.119 57.407c-4.074 0-7.396 3.324-7.396 7.397s3.322 7.396 7.396 7.396 7.397-3.323 7.397-7.396c-.107-4.073-3.43-7.397-7.397-7.397zM94.323 79.275c-.428-3.216-2.465-5.788-5.252-6.86-1.716 1.393-3.86 2.25-6.217 2.25-2.359 0-4.503-.857-6.219-2.25-1.821.75-3.215 2.036-4.18 3.644 2.895 1.716 5.039 4.717 5.467 8.254l.536 4.824c1.393.107 2.894.215 4.396.215 3.858 0 7.502-.43 10.933-1.18.857-.213 1.501-1.072 1.393-1.93l-.857-6.968zM82.853 57.407c-4.074 0-7.397 3.324-7.397 7.397S78.78 72.2 82.853 72.2s7.396-3.323 7.396-7.396-3.322-7.397-7.396-7.397z'></path>
			<mask
				id='mask2_413_1653'
				style={{ maskType: "luminance" }}
				width='26'
				height='18'
				x='51'
				y='77'
				maskUnits='userSpaceOnUse'>
				<path
					fill='#fff'
					d='M51.541 77.483h24.917v17.245H51.541V77.483z'></path>
			</mask>
			<g mask='url(#mask2_413_1653)'>
				<path
					className={fillHover}
					d='M75.456 84.635c-.43-3.216-2.466-5.788-5.252-6.86-1.716 1.393-3.86 2.25-6.22 2.25-2.356 0-4.5-.857-6.216-2.25-2.787 1.178-4.931 3.752-5.252 6.86l-.858 6.968c-.108.857.428 1.716 1.394 1.929 3.43.75 7.182 1.18 10.933 1.18 3.86 0 7.504-.43 10.935-1.18.857-.213 1.5-1.072 1.393-1.93l-.857-6.967z'></path>
			</g>
			<path
				className={fillHover}
				d='M63.985 62.767c-4.074 0-7.396 3.322-7.396 7.397 0 4.073 3.322 7.396 7.396 7.396 4.075 0 7.397-3.323 7.397-7.396 0-4.075-3.323-7.397-7.397-7.397z'></path>
		</svg>
	);
}

export default Icon;
